import React, { useState } from 'react';
import { Container, Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import OverviewTab from './OverviewTab';
import PendingRequestsTab from './PendingRequestsTab';
import StaffBalancesTab from './StaffBalancesTab';
import RollBackTab from './RollBackTab';
import TILDetectionTab from './TILDetectionTab';
import AuditLogTab from './AuditLogTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`leave-tabpanel-${index}`}
      aria-labelledby={`leave-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `leave-tab-${index}`,
    'aria-controls': `leave-tabpanel-${index}`,
  };
}

const LeaveManagementDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Leave Management Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage leave requests, staff balances, and TIL detection
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="leave management tabs"
            variant="fullWidth"
          >
            <Tab label="Overview" {...a11yProps(0)} />
            <Tab label="Staff Balances" {...a11yProps(1)} />
            <Tab label="Pending Requests" {...a11yProps(2)} />
            <Tab label="Roll Back" {...a11yProps(3)} />
            <Tab label="TIL Detection" {...a11yProps(4)} />
            <Tab label="Audit Log" {...a11yProps(5)} />
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <OverviewTab />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <StaffBalancesTab />
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <PendingRequestsTab />
        </TabPanel>

        

        <TabPanel value={activeTab} index={3}>
          <RollBackTab />
        </TabPanel>

        <TabPanel value={activeTab} index={4}>
          <TILDetectionTab />
        </TabPanel>

        <TabPanel value={activeTab} index={5}>
          <AuditLogTab />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default LeaveManagementDashboard;